export function fillFiltersFromStock(stock, attribute) {
  return stock
    .reduce((values, item) => {
      if (item[attribute] && values.indexOf(item[attribute]) < 0) {
        values.push(item[attribute]);
      }

      return values;
    }, [])
    .sort();
}

export function fillFilters(values) {
  return values;
}
